export const environement = {
	name: 'dev',
	PRODUCTION: false,
	API_URL: 'https://api-dev.eps-top.fr/api',
};
